import { Component } from '@angular/core';

@Component({
  selector: 'realwear-cloud-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app-marketplace';
}
